import { TypedDocumentNode, gql } from '@apollo/client';

import { usePaginatedQuery } from '@sorare/core/src/hooks/graphql/usePaginatedQuery';

import { UserList } from '../UserList';
import { UserNetwork } from '../UserNetwork';
import type {
  NetworkFollowingQuery,
  NetworkFollowingQueryVariables,
} from './__generated__/index.graphql';

const NETWORK_FOLLOWING_QUERY = gql`
  query NetworkFollowingQuery($slug: String!, $after: String) {
    user(slug: $slug) {
      slug
      following(first: 18, after: $after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          slug
          ...UserNetwork_user
        }
      }
    }
  }
  ${UserNetwork.fragments.user}
` as TypedDocumentNode<NetworkFollowingQuery, NetworkFollowingQueryVariables>;

type Props = {
  user: {
    slug: string;
  };
};

export const Following = ({ user }: Props) => {
  const { loading, data, loadMore } = usePaginatedQuery(
    NETWORK_FOLLOWING_QUERY,
    {
      variables: { slug: user.slug },
      connection: 'UserWithSubscriptionSlugConnection',
    }
  );

  const load = () => {
    loadMore(false, {
      after: data?.user?.following.pageInfo.endCursor,
      slug: user.slug,
    });
  };

  return (
    <UserList
      users={data?.user?.following.nodes || []}
      renderUser={u => <UserNetwork key={u.slug} user={u} />}
      loading={loading}
      loadMore={load}
      hasNextPage={data?.user?.following.pageInfo.hasNextPage || false}
    />
  );
};
